import { render, staticRenderFns } from "./kiosk-warehouse.vue?vue&type=template&id=0287c8a1&"
import script from "./kiosk-warehouse.vue?vue&type=script&lang=js&"
export * from "./kiosk-warehouse.vue?vue&type=script&lang=js&"
import style0 from "./kiosk-warehouse.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports